import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import * as React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { I18nextProvider } from 'react-i18next'

import { OrderNoProvider } from '@/components/pages/OrderCompleted/store'
import i18n from '@/lib/i18n'
import { ProxyStoreProvider } from '@/providers/proxyStore/ProxyStoreContext'

type AppProviderProps = {
  queryClient: QueryClient
  children: React.ReactNode
}

export const AppProvider = ({ queryClient, children }: AppProviderProps) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return isClient ? (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        {process.env.NEXT_IS_TEST !== 'true' && <ReactQueryDevtools />}
        <Toaster />
        <ProxyStoreProvider>
          <OrderNoProvider>{children}</OrderNoProvider>
        </ProxyStoreProvider>
      </I18nextProvider>
    </QueryClientProvider>
  ) : null
}
